module.exports = __webpack_public_path__ + "static/media/cookies-n-cream.5e85a280.png";